module.exports = __webpack_public_path__ + "img/cuoti.f9acc501.png";